<div class="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-station-cream">
  <div class="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
    <h1 class="text-3xl font-bold mb-2 text-flap-black">Log in</h1>
    <p class="text-rail-gray mb-8">Welcome back to FlippyBoards.com.</p>

    @if (socialError(); as err) {
      <div
        class="mb-6 px-4 py-3 rounded-lg bg-signal-orange/10 border-2 border-signal-orange text-flap-black text-sm"
        role="alert"
      >
        {{ err }}
      </div>
    }

    @if (justVerified) {
      <div
        class="mb-6 px-4 py-3 rounded-lg bg-flap-yellow/20 border-2 border-flap-yellow text-flap-black text-sm"
      >
        Email verified. You can now log in.
      </div>
    }

    @if (justReset) {
      <div
        class="mb-6 px-4 py-3 rounded-lg bg-flap-yellow/20 border-2 border-flap-yellow text-flap-black text-sm"
      >
        Password updated. You can now log in with your new password.
      </div>
    }

    <app-social-sign-in [redirectPath]="redirectPath" (failed)="socialError.set($event)" />

    <form (ngSubmit)="submit()" class="space-y-5">
      <div>
        <label for="email" class="block text-sm font-semibold text-flap-black mb-1">Email</label>
        <input
          id="email"
          type="email"
          autocomplete="email"
          required
          [ngModel]="email()"
          (ngModelChange)="email.set($event)"
          name="email"
          class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
        />
      </div>

      <div>
        <div class="flex items-center justify-between mb-1">
          <label for="password" class="block text-sm font-semibold text-flap-black">Password</label>
          <a
            routerLink="/forgot-password"
            class="text-xs text-signal-orange font-semibold hover:underline"
            >Forgot password?</a
          >
        </div>
        <input
          id="password"
          type="password"
          autocomplete="current-password"
          required
          [ngModel]="password()"
          (ngModelChange)="password.set($event)"
          name="password"
          class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
        />
      </div>

      @if (error(); as err) {
        <p class="text-sm text-signal-orange">{{ err }}</p>
      }

      <button
        type="submit"
        [disabled]="submitting()"
        class="w-full px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
      >
        {{ submitting() ? 'Logging in…' : 'Log in' }}
      </button>
    </form>

    <p class="mt-6 text-center text-sm text-rail-gray">
      No account?
      <a routerLink="/signup" class="text-signal-orange font-semibold hover:underline">Sign up</a>
    </p>

    <p class="mt-2 text-center text-sm text-rail-gray">
      Didn't get your verification email?
      <button
        type="button"
        (click)="resendVerification()"
        [disabled]="resending() || resendSent()"
        class="text-signal-orange font-semibold hover:underline disabled:opacity-60 disabled:cursor-not-allowed disabled:no-underline cursor-pointer"
      >
        {{ resending() ? 'Sending…' : 'Resend it' }}
      </button>
    </p>

    @if (resendSent()) {
      <p class="mt-2 text-center text-sm text-flap-black">
        If that email needs verification, a new link is on its way. Check your spam folder too.
      </p>
    } @else if (resendError(); as err) {
      <p class="mt-2 text-center text-sm text-signal-orange">{{ err }}</p>
    }
  </div>
</div>
